document.addEventListener("DOMContentLoaded", loadOrnaments());
document.addEventListener('shopify:section:load', function (event) {
  loadOrnaments ();
})
function loadOrnaments () {
  const swiperElement = document.querySelector('.ornament-carousel__carousel')
  // 3 product rows should be as large as possible
  const ornamentCarousel = new Swiper(".ornament-carousel__carousel", {
    slidesPerView: (swiperElement?.dataset?.ornamentsCountMobile == 3 ? 'auto' : swiperElement?.dataset?.ornamentsCountMobile) || 2,
    slidesPerGroup: 1,
    spaceBetween: (swiperElement?.dataset?.ornamentsCountMobile == 3 ? 0 : 15),
    navigation: {
      nextEl: ".ornament-carousel__button-next",
      prevEl: ".ornament-carousel__button-prev",
    },
    breakpoints: {
      648: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      890: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 25,
      },
      1100: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 25,
      },
      1300: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 25,
      },
    },
  });

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;

  if (!prefersReducedMotion) {
    const ornamentCarouselWrapper = document.querySelector(".ornament-carousel");
    const ornaments = ornamentCarouselWrapper.querySelectorAll(".ornament");

    for (const ornament of ornaments) {
      ornament.dataset.animation = "false";
    }

    const mouse = {
      x: 0,
      y: 0,
      speed: 0,
      angle: 0,
    };

    let time = Date.now();

    function updateMouse(e) {
      const currentTime = Date.now();
      const deltaX = e.clientX - mouse.x;
      const deltaY = e.clientY - mouse.y;
      const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);

      mouse.speed = +(distance / (currentTime - time)).toFixed(4);
      mouse.angle = +(Math.atan2(deltaY, deltaX) * (180 / Math.PI)).toFixed(4);
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      time = currentTime;
    }

    function animateOrnament(ornament, direction, distance) {
      ornament.dataset.animation = "true";

      ornament.style.setProperty("--rotation1", `${direction * distance}deg`);
      ornament.style.setProperty("--rotation2", `${direction * -distance * 0.75}deg`);
      ornament.style.setProperty("--rotation3", `${direction * distance * 0.5}deg`);
      ornament.style.setProperty("--rotation4", `${direction * -distance * 0.25}deg`);
      ornament.style.setProperty("--rotation5", `${direction * distance * 0.1}deg`);
      ornament.style.animation = `ornament-animation 1.3s ease-out forwards`;

      ornament.addEventListener("animationend", function () {
        ornament.dataset.animation = "false";
        ornament.style.animation = "none";
      });
    }

    if (window.matchMedia("(hover:hover) and (pointer:fine)").matches) {
      ornamentCarouselWrapper.addEventListener("mousemove", function (e) {
        updateMouse(e);
        for (const ornament of ornaments) {
          if (ornament.contains(e.target) && ornament.dataset.animation == "false") {
            const direction = mouse.angle > 0 ? 1 : -1;
            const distance = Math.min(mouse.speed * 1.5, 3);
            animateOrnament(ornament, direction, distance);
          }
        }
      });
    }

    ornamentCarousel.on("slideNextTransitionEnd", function () {
      for (const ornament of ornaments) {
        ornament.style.animation = "none";
        ornament.offsetHeight;
        animateOrnament(ornament, 1, 2);
      }
    });

    ornamentCarousel.on("slidePrevTransitionEnd", function () {
      for (const ornament of ornaments) {
        ornament.style.animation = "none";
        ornament.offsetHeight;
        animateOrnament(ornament, -1, 2);
      }
    });
  }
}